import { render, staticRenderFns } from "./XomeConfiguration.vue?vue&type=template&id=5a3575bc&"
import script from "./XomeConfiguration.vue?vue&type=script&lang=js&"
export * from "./XomeConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports